import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "relative bottom-0 left-0 right-0 py-2 text-gray-900 w-full px-0 lg:px-2 text-[10px]" }
const _hoisted_3 = { class: "flex uppercase tracking-[0.2em] text-gray-900 mb-0.5 flex flex-wrap gap-x-1 w-full justify-between" }
const _hoisted_4 = { class: "flex justify-between items-end w-full items-start" }
const _hoisted_5 = { class: "grow" }
const _hoisted_6 = { class: "uppercase tracking-[0.2em] flex flex-wrap gap-x-2" }

import FastDelivery from './icons/fastDelivery.vue';
import DiamondImage from '../diamondImage.vue';
import {Config} from "@/assets/ts/config";
import {SetWidget} from "@/assets/ts/stepWidget";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchResultDiamond',
  props: {
    diamond: {}
  },
  setup(__props: any) {

const props = __props;

const setWidgetApi = new SetWidget()

const getDiamondLink = () => {
  if (setWidgetApi.getConfSession() !== null) {
    return `${Config.getBaseUrl()}${setWidgetApi.getConfSession()}/diamonds/${props.diamond.link}`
  } else {
    return `${Config.getBaseUrl()}diamonds/${props.diamond.link}`
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: getDiamondLink(),
    class: "relative flex flex-col items-center hover:shadow-lg transition-shadow overflow-hidden group aspect-square"
  }, [
    (__props.diamond.delivery_time < 2)
      ? (_openBlock(), _createBlock(FastDelivery, {
          key: 0,
          class: "absolute top-1 right-1 w-8 h-8 text-brand-main z-10"
        }))
      : _createCommentVNode("", true),
    _createVNode(DiamondImage, { diamond: __props.diamond }, null, 8, ["diamond"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(__props.diamond.size.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})) + " ct.", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-gray-900" }, "|", -1)),
        _createElementVNode("span", null, _toDisplayString(__props.diamond.type === 'lab' ? 'Labor' : 'Natur'), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-gray-900" }, "|", -1)),
        _createElementVNode("span", null, _toDisplayString(__props.diamond.institute), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(__props.diamond.color), 1),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-900" }, "|", -1)),
            _createElementVNode("span", null, _toDisplayString(__props.diamond.clarity), 1),
            (__props.diamond.form === 'BR')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-gray-900" }, "|", -1)),
                  _createElementVNode("span", null, _toDisplayString(__props.diamond.cut), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("p", {
          class: _normalizeClass(["w-2/5 text-[14px] text-right font-serif whitespace-nowrap", __props.diamond.special ? 'text-red-600' : ''])
        }, _toDisplayString(__props.diamond.price.toLocaleString('de-DE')) + " € ", 3)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})